module.exports = __webpack_public_path__ + "img/7-Silver V 9705.jpg";